<div class="modal fade" id="minSignUpModal" tabindex="-1" aria-labelledby="minSignUpModalLabel" >
  <div class="modal-dialog modal-fullscreen-sm-down modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5 fw-bold ms-auto" id="minSignUpModalLabel">{{ 'REGISTER.TITLE2' | translate }}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" #closeSignUpButton></button>
      </div>
      <div class="modal-body">
        <div *ngIf="currentStep === 'form'">
          <p class="text-center text-darker me-0 me-lg-4">{{ ('REGISTER.STEP2_TITLE') | translate }}</p>
          <form  class="needs-validation" novalidate (ngSubmit)="submitForm()" [formGroup]="minRegForm">

            <div class="mb-2">
              <label class="form-label mb-2" for="signupEmail">{{ 'REGISTER.EMAIL_LABEL' | translate }}</label>
              <input class="form-control" type="email" id="signupEmail" placeholder="{{ 'REGISTER.EMAIL_PLACEHOLDER' | translate }}" required formControlName="email" [ngClass]="{'is-invalid': regSubmit && regForm['email'].errors}">
              <div class="invalid-feedback" *ngIf="!minRegForm.controls['email'].errors?.['validationErrorFromServer']">{{ 'REGISTER.EMAIL_ALERT' | translate }}</div>
              <div class="invalid-feedback" *ngIf="minRegForm.controls['email'].errors?.['validationErrorFromServer']">
                {{ minRegForm.controls['email'].errors?.['validationErrorFromServer'] }}
              </div>
            </div>

            <div class="mb-2">
              <label class="form-label mb-2" for="username">{{ 'REGISTER.LOGIN_LABEL' | translate }} </label>
              <input class="form-control" type="text" id="username" placeholder="{{ 'REGISTER.LOGIN_PLACEHOLDER' | translate }}" required formControlName="username" [ngClass]="{'is-invalid': regSubmit && regForm['username'].errors}" autocomplete="off">
              <div class="invalid-feedback" *ngIf="!minRegForm.controls['username'].errors?.['validationErrorFromServer']">{{ 'REGISTER.LOGIN_ALERT' | translate }}</div>
              <div class="invalid-feedback" *ngIf="minRegForm.controls['username'].errors?.['validationErrorFromServer']">
                {{ minRegForm.controls['username'].errors?.['validationErrorFromServer'] }}
              </div>
            </div>

            <div class="mb-2">
              <label class="form-label mb-2" for="reg_password">{{ 'REGISTER.PW_LABEL' | translate }}</label>
              <div class="position-relative">
                <input class="form-control" [type]="fieldTextType ? 'text' : 'password'" id="reg_password" required formControlName="password"
                       placeholder="{{ 'REGISTER.PW_PLACEHOLDER' | translate }}"
                       [ngClass]="{'is-invalid': regSubmit && regForm['password'].errors}">
                <label class="password-toggle-btn" [ngClass]="{'invalid-toggle-btn': regSubmit && regForm['password'].errors}" aria-label="Show/hide password">
                  <input class="password-toggle-check" type="checkbox">
                  <span class="password-toggle-indicator" [ngClass]="{'opacity-50': !fieldTextType, 'opacity-1': fieldTextType}" (click)="toggleFieldTextType()"><app-svg-icon class="variable-svg-icon d-block" [pathIdentifier]="'eye'"></app-svg-icon>
                  </span>
                </label>
                <div class="invalid-feedback" *ngIf="!minRegForm.controls['password'].errors?.['validationErrorFromServer']">{{ 'REGISTER.PW_ALERT' | translate }}</div>
                <div class="invalid-feedback" *ngIf="minRegForm.controls['password'].errors?.['validationErrorFromServer']">
                  {{ minRegForm.controls['password'].errors?.['validationErrorFromServer'] }}
                </div>
              </div>
            </div>

            <div class="row row-cols-1 row-cols-sm-2">
              <div class="col mb-2">
                <label class="form-label mb-1" for="firstName">{{ 'REGISTER.FNAME_LABEL' | translate }}</label>
                <input class="form-control" type="text" id="firstName" placeholder="{{ 'REGISTER.FNAME_LABEL' | translate }}" required formControlName="fname" [ngClass]="{'is-invalid': regSubmit && regForm['fname'].errors}" autocomplete="off">
                <div class="invalid-feedback">{{ 'REGISTER.FNAME_ALERT' | translate }}</div>
              </div>
              <div class="col mb-2">
                <label class="form-label mb-1" for="lastName">{{ 'REGISTER.LNAME_LABEL' | translate }}</label>
                <input class="form-control" type="text" id="lastName" placeholder="{{ 'REGISTER.LNAME_LABEL' | translate }}" required formControlName="lname" [ngClass]="{'is-invalid': regSubmit && regForm['lname'].errors}" autocomplete="off">
                <div class="invalid-feedback">{{ 'REGISTER.FNAME_ALERT' | translate }}</div>
              </div>
            </div>

            <div class="mb-2">
              <label class="form-label mb-1" for="birthYear">{{ 'REGISTER.BIRTH_DATE_LABEL' | translate }}</label>
              <div class="row">
                <div class="col-12 col-sm-4 mb-2 mb-sm-0">
                  <select class="form-select" id="birthYear" formControlName="birthYear" [ngClass]="{'is-invalid': regSubmit && (regForm['birthYear'].errors || minRegForm.errors?.['ageInvalid'])}">
                    <option selected value="">{{ 'REGISTER.BIRTH_YEAR_LABEL' | translate }}</option>
                    <option *ngFor="let year of yearOptions" [value]="year">{{year}}</option>
                  </select>
                </div>
                <div class="col-12 col-sm-5 mb-2 mb-sm-0" *ngIf="monthOptions.length">
                  <select class="form-select" id="birthMonth" formControlName="birthMonth" [ngClass]="{'is-invalid': regSubmit && (regForm['birthMonth'].errors || minRegForm.errors?.['ageInvalid'])}">
                    <option selected value="">{{ 'REGISTER.BIRTH_MONTH_LABEL' | translate }}</option>
                    <option *ngFor="let month of monthOptions" [value]="month">{{ 'REGISTER.BIRTH_MONTH_'+ month | translate  }}</option>
                  </select>
                </div>
                <div class="col-12 col-sm-3 mb-2 mb-sm-0" *ngIf="dayOptions.length">
                  <select class="form-select" id="birthDay" formControlName="birthDay" [ngClass]="{'is-invalid': regSubmit && (regForm['birthDay'].errors || minRegForm.errors?.['ageInvalid'])}">
                    <option selected value="">{{ 'REGISTER.BIRTH_DAY_LABEL' | translate }}</option>
                    <option *ngFor="let day of dayOptions" [value]="day">{{ day }}</option>
                  </select>
                </div>
              </div>
              <div class="invalid-feedback d-block" *ngIf="regSubmit && minRegForm.errors?.['ageInvalid']">
                {{ 'REGISTER.BIRTH_ALERT' | translate: {minimalAge: minimalAge} }}
              </div>
            </div>

            <div class="row row-cols-1 row-cols-sm-2">
              <div class="col mb-2">
                <label class="form-label mb-1" for="country">{{ 'REGISTER.COUNTRY_LABEL' | translate }}</label>
                <select class="form-select" id="country" formControlName="country" [ngClass]="{'is-invalid': regSubmit && regForm['country'].errors}">
                  <option selected value="">{{ 'REGISTER.COUNTRY_PLACEHOLDER' | translate }}</option>
                  <option *ngFor="let country of countryOptions" [value]="country.code">{{ country.name }}</option>
                </select>
              </div>
              <div class="col mb-2">
                <label class="form-label mb-1" for="currency">{{ 'REGISTER.CURRENCY_LABEL' | translate }}</label>
                <select class="form-select" id="currency" formControlName="currency" [ngClass]="{'is-invalid': regSubmit && regForm['currency'].errors}">
                  <option selected value="">{{ 'REGISTER.CURRENCY_LABEL' | translate }}</option>
                  <option *ngFor="let currency of currencyOptions" [value]="currency.code">{{ currency.name }}</option>
                </select>
              </div>
            </div>

<!--            TODO optional fields -->
<!--            <div class="form-check mb-2">-->
<!--              <input class="form-check-input" type="checkbox" value="" id="showOptional" [(ngModel)]="showOptionalFields" [ngModelOptions]="{standalone: true}" (change)="toggleOptionalFields()" >-->
<!--              <label class="form-check-label" for="showOptional">-->
<!--                {{ "REGISTER.EXTRA_INFO_LABEL" | translate }}-->
<!--              </label>-->
<!--            </div>-->
<!--            <div *ngIf="showOptionalFields" formGroupName="optionalFields">-->
<!--             <div class="row row-cols-1 row-cols-sm-2">-->
<!--               <div class="col mb-2">-->
<!--                 <label class="form-label mb-1" for="firstName">{{ 'REGISTER.FNAME_LABEL' | translate }}</label>-->
<!--                 <input class="form-control" type="text" id="firstName" placeholder="{{ 'REGISTER.FNAME_LABEL' | translate }}" formControlName="fname" [ngClass]="{'is-invalid': regSubmit && showOptionalFields && optionalFields.controls['fname'].errors}">-->
<!--                 <div class="invalid-feedback">{{ 'REGISTER.FNAME_ALERT' | translate }}</div>-->
<!--               </div>-->
<!--               <div class="col mb-2">-->
<!--                 <label class="form-label mb-1" for="lastName">{{ 'REGISTER.LNAME_LABEL' | translate }}</label>-->
<!--                 <input class="form-control" type="text" id="lastName" placeholder="{{ 'REGISTER.LNAME_LABEL' | translate }}" formControlName="lname" [ngClass]="{'is-invalid': regSubmit && showOptionalFields && optionalFields.controls['lname'].errors}">-->
<!--                 <div class="invalid-feedback">{{ 'REGISTER.FNAME_ALERT' | translate }}</div>-->
<!--               </div>-->
<!--             </div>-->
<!--            </div>-->


            <button *ngIf="!isLoading, else loadingSpinner" class="btn btn-success btn-lg w-100 mt-4" type="submit">
              {{ 'REGISTER.NEXT_LABEL' | translate }}</button>
          </form>
        </div>

        <div *ngIf="currentStep === 'terms'">
            <p class="text-center text-darker me-0 me-lg-4">{{ ('REGISTER.STEP4_TITLE') | translate }}</p>

          <div class="terms-container">
            <div class="terms-scrollbox border p-3">
              <app-terms></app-terms>
            </div>
          </div>

          <div class="my-4">
            <div class="form-check my-3">
              <input class="form-check-input" type="checkbox" id="agree-to-terms" [formControl]="agreeTerms"
                     [ngClass]="{'is-invalid': regSubmit && !agreeTerms.value}" required>
              <label class="form-check-label" for="agree-to-terms">{{ 'REGISTER.TERMS_LABEL' | translate }} {{ 'REGISTER.TERMS_LINK' | translate }}</label>
            </div>
          </div>
          <div class="row" *ngIf="!isLoading; else loadingSpinner">
            <div class="col">
              <button class="btn btn-outline-success btn-lg w-100" type="button" (click)="goToPrevStep()">{{ 'REGISTER.PREV_LABEL' | translate }}</button>
            </div>
            <div class="col">
              <button class="btn btn-success btn-lg w-100" type="button" (click)="finalizeRegistration()">{{ 'REGISTER.FINALIZE_BTN' | translate }}</button>
            </div>
          </div>
        </div>


        <div class="text-center mt-2">
          <p class="mb-5 mb-sm-0 py-2">
            <span>{{ 'REGISTER.FOR_MEMBER_LABEL' | translate }}</span>
            <a class="text-decoration-none text-nowrap ms-2" data-bs-target="#signInModal" data-bs-toggle="modal" href="#signInModal" >{{ 'LOGIN.TITLE' | translate }}</a>
          </p>
        </div>

      </div>


    </div>
  </div>
</div>

<ng-template #loadingSpinner>
  <div *ngIf="isLoading" class="d-flex justify-content-center my-4">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</ng-template>
